import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { TheNightlyTheme, breakpointMax, metrics } from '../../../__styling'
import TheNightlyLogo from '../../../logos/TheNightlyLogo/TheNightlyLogo'
import { textMixin } from '../../../mixins/TextMixin/TextMixin'
import StyledWardenButton from '../components/StyledWardenButton'

const palette = tokens.thenightly.colors.palette

export interface StyledContainerProps {
    showAsDivider?: boolean
}

export const StyledContainer = styled('div')<StyledContainerProps>(
    ({ showAsDivider = false }) => ({
        background: tokens.thenightly.colors.palette.neutral[0],
        margin: `${metrics.thenightly.margins.xxxxl}px 0`,

        padding: showAsDivider ? 0 : `${metrics.thenightly.margins.m2l}px 0`,
        borderTop: `0.5px solid ${tokens.thenightly.colors.palette.neutral[20]}`,
        borderBottom: showAsDivider
            ? '0px'
            : `0.5px solid ${tokens.thenightly.colors.palette.neutral[20]}`,
        [breakpointMax('sm')]: {
            display: 'flex',
            margin: `${metrics.thenightly.margins.xxl}px 0`,
            justifyContent: 'space-around',
            flexDirection: 'column',
        },
    }),
)

export const StyledRowContainer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',

    [breakpointMax('sm')]: {
        flexDirection: 'column',
    },
})

export const StyledColumnContainer = styled('div')({
    margin: 0,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',

    [breakpointMax('sm')]: {
        flexDirection: 'column',
        gap: metrics.thenightly.margins.sm,
        width: '90%',
    },
})

export const StyledTNHeaderLogo = styled(TheNightlyLogo)({
    width: calcRem(40),
    height: calcRem(40),
    display: 'block',
    marginRight: metrics.thenightly.margins.md,

    [breakpointMax('sm')]: {
        width: calcRem(32),
        height: calcRem(32),
    },
})

export const StyledTextContainer = styled.p(({ theme }) => [
    { color: palette.neutral[100], margin: 0 },
    textMixin(theme as TheNightlyTheme, 'subheading'),
])

export const StyledBodyTextContainer = styled.p<{
    marginBottom?: number
    marginTop?: number
}>(({ theme, marginTop, marginBottom }) => [
    {
        color: palette.neutral[100],
        margin: `${metrics.thenightly.margins.m2l}px 0 0`,
    },
    textMixin(theme as TheNightlyTheme, 'body-alt'),
])

// TN Puzzles Inline CTA Styles
export const StyledPuzzlesCTAContainer = styled('div')<StyledContainerProps>(
    ({ showAsDivider = false }) => ({
        background: tokens.thenightly.colors.palette.neutral[0],
        margin: `${metrics.thenightly.margins.xxl}px 0`,

        padding: showAsDivider ? 0 : `${metrics.thenightly.margins.m2l}px 0`,
        borderTop: `0.5px solid ${tokens.thenightly.colors.palette.neutral[20]}`,
        borderBottom: showAsDivider
            ? '0px'
            : `0.5px solid ${tokens.thenightly.colors.palette.neutral[20]}`,
        [breakpointMax('sm')]: {
            margin: `0`,
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'column',
        },
    }),
)

export const StyledCTAWardenButton = styled(StyledWardenButton)({
    margin: `${metrics.thenightly.margins.m2l}px auto 0`,
})

export const StyledCTAColumn = styled(StyledColumnContainer)({
    flexDirection: 'column',
})

export const StyledTextLink = styled('a')({
    textDecoration: 'underline',
    // color: palette.starlight.default,
    fontSize: metrics.thenightly.baseFontSize,
    lineHeight: 1.5,
    fontStyle: 'normal',
    fontWeight: 400,
    paddingLeft: calcRem(8),
    '&:hover': {
        cursor: 'pointer',
    },
})
